// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout__button[data-v-c4195356]{background-color:var(--c-primary);color:var(--color-white);border-radius:3px;border:none;transition:all .3s ease;cursor:pointer;margin-left:20px;&:hover{background-color:var(--c-primary-variant-second)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
